import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Root = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: 340,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  background: theme.palette.background.paper,
  ...theme.scrollbars.paper,
  paddingTop: 16,
}));